import { render, staticRenderFns } from "./CButtonRouterLink.vue?vue&type=template&id=33c6ffa1&"
import script from "./CButtonRouterLink.vue?vue&type=script&lang=js&"
export * from "./CButtonRouterLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports